export default "__VITE_PUBLIC_ASSET__e1ad0e96__"